export default {
    /**
     * Get Osteopathic recommendation text
     * @param score
     * @returns {string}
     */
    getRecommendation(score) {
        if (score > 75) {
            return 'Your applicant profile likely does not need osteopathic schools';
        }
        if (score > 66) {
            return 'You may want to consider applying to osteopathic schools';
        }
        if (score > 55) {
            return 'Highly consider applying to osteopathic schools';
        }

        return 'You should apply to 15-25 osteopathic schools';
    },

    /**
     * Get number of Osteopathic schools to apply.
     * @param score
     * @returns {number}
     */
    getNumber(score) {
        if (score > 75) {
            return 0;
        }
        if (score > 66) {
            return 5;
        }
        if (score > 60) {
            return 10;
        }
        if (score > 55) {
            return 15;
        }

        return 25;
    },
};
